module.exports = __webpack_public_path__ + "static/media/FiraSans-ExtraBoldItalic.e324c570.ttf";